export const FILE_MANAGER_CONSTANTS = {
  MAX_UPLOAD_FILE_MB: 50, // 50 MB
  MAX_UPLOAD_FILE_SIZE: 1024 * 1024 * 50, // 50 MB
}

export const UPLOAD_TYPES = {
  MEMO_UPLOAD: 'MemoUpload',
  UPLOAD: 'Upload',
  REMITTANCE_UPLOAD: 'RemitanceUpload',
  PROMOTION_UPLOAD: 'PromotionUpload',
  UPLOAD_WITH_EXTRACT_TIME: 'UploadWithExtractTime',
  DISPUTE: 'Dispute',
}

export const FILE_MESSAGES = {
  FILE_UPLOAD_FAILED: 'Failed to upload files',
  SELECT_AT_LEAST_ONE_FILE: 'Please select at least one file',
  SELECT_DOCUMENT_TYPE: 'Please select document type',
  FILE_SIZE_LIMIT_EXCEEDED:
    'File size exceeds the maximum limit ' +
    FILE_MANAGER_CONSTANTS.MAX_UPLOAD_FILE_MB +
    ' MB',
  MISMATCH_FILES_AND_URLS: 'Mismatch in number of files and signed URLs',
  FAILED_TO_GENERATE_SIGNED_URLS: 'Failed to generate Signed URLs',
  NO_FILES_PROVIDED: 'No files provided',
}
